<template>
  <c-dialog v-model="isShow" :option="popOption" @close="$emit('close')">
    <template slot="body">
      <div :class="['dialog', 'dialog--default', !isMobile ? 'dialog--pc' : '']">
        <div class="dialog-content">
          <div class="win-prize-body">
            <!-- 带tab切换的样式可配置，通过用户信息组件传入配置项 礼包记录 物品记录 -->
            <div v-if="params.isResourcesIssue" class="tab-title" :style="tabTitleborderStyle">
              <span
                @click="tabTitleClick(1)"
                :class="['tab-title-left', tabCurrentIndex === 1 ? 'tab-title-active' : '']"
                >{{ tabTitle.tabTitleAms || '礼包记录' }}
              </span>
              <span
                @click="tabTitleClick(2)"
                :class="['tab-title-right', tabCurrentIndex === 2 ? 'tab-title-active' : '']"
                >{{ tabTitle.tabTitleResourcesRecord || '物品记录' }}
              </span>
            </div>
            <ul class="win-prize-body-title" :style="winPrizeRecordTitleBgStyle">
              <li class="win-prize-body-title-name" :style="prizeRecordItemTitleCommonStyle">
                {{ itemTitle[0] || '奖品' }}
              </li>
              <li class="win-prize-body-title-time" :style="prizeRecordItemTitleCommonStyle">
                {{ itemTitle[1] || '时间' }}
              </li>
              <li class="win-prize-body-title-action" :style="prizeRecordItemTitleCommonStyle">
                {{ itemTitle[2] || '操作' }}
              </li>
            </ul>
            <!-- 兑换记录 -->
            <template v-if="list.length > 0">
              <!--              // 滚动窗口-->
              <div class="win-prize-body-record-scroll-window" :style="PrizeBodyRecordScrollStyle">
                <ul class="win-prize-body-record" :style="winPrizeRecordBottomBorderStyle" v-for="(item, index) of list"
                  :key="index">
                  <li ref="textDecorationPopups" class="win-prize-body-record-name">
                    <span :style="prizeRecordItemCommonStyle" v-if="item.gift_name.length <= 12 && !isMobile">
                    {{ item.gift_name}}</span>
                    <span :style="prizeRecordItemCommonStyle" v-if="item.gift_name.length <= 8 && isMobile">
                    {{ item.gift_name}}</span>
                    <!-- 弹出层 -->
                    <div
                      ref="textDecorationPopupsPointer"
                      class="text-decoration-popups"
                      v-if="item.gift_name.length > 8 && popupsIndex === index">
                      <div class="text-decoration-popups-pointer"></div>
                      <span ref="decorationPopupsText">{{ item.gift_name }}</span>
                    </div>
                    <span :style="prizeRecordItemCommonStyle" v-if="item.gift_name.length > 12 && !isMobile"
                      class="text-decoration text-weight"
                      @click="showDetail(item.gift_name, index)">
                      {{ item.gift_name }}
                    </span>
                    <span :style="prizeRecordItemCommonStyle" v-if="item.gift_name.length > 8 && isMobile"
                      class="text-decoration text-weight"
                      @click="showDetail(item.gift_name, index)">
                      {{ item.gift_name }}
                    </span>
                  </li>
                  <li class="win-prize-body-record-time" :style="prizeRecordItemTimeStyle">{{ item.show_gift_time }}
                  </li>
                  <!-- 资源发货 -->
                  <li
                    v-if="tabCurrentIndex === 2"
                    class="win-prize-body-record-note text-decoration text-weight"
                    @click="showDetail(item.notes, index)" :style="prizeRecordItemTimeStyle">{{ item.notes }}
                  </li>
                  <!-- ams礼包发货 -->
                  <li v-else class="win-prize-body-record-action">
                    <template v-if="checkIsSurvey(item.gift_id)">
                      <span class="text-decoration" :style="operateTextStyle"
                        @click="actionByType(item.gift_id, 'privateQualification')">填写问卷</span>
                    </template>
                    <template v-else-if="checkIsMatchGift(item.gift_id, 'packageRealGift')">
                      <span :style="operateTextStyle" class="text-decoration" @click="$emit('fill-address')">填写地址</span>
                    </template>
                    <template v-else-if="checkIsMatchGift(item.gift_id, 'cash')">
                      <span class="text-decoration" :style="operateTextStyle"
                        @click="$emit('package:reward:record:event:wx-fill')">绑定微信</span>
                    </template>
                    <template v-else-if="checkIsMatchGift(item.gift_id, 'redPacket')">
                      <span
                        class="gift-record-action-link"
                        :style="operateTextStyle"
                        @click="$emit('package:reward:record:event:red-packet', item)">领取红包</span>
                    </template>
                    <template v-else-if="checkIsMatchGift(item.gift_id, 'welfareCenter')">
                      <a
                        class="gift-record-action-link"
                        :style="operateTextStyle"
                        @click="goToWelfareCenter(item.gift_id)"
                      >查看</a>
                    </template>
                    <!-- 是否显示cdk 或是否实物地址 -->
                    <template v-else-if="item.package_cdkey || item.package_real_flag === '1'">
                        <div class="address-cdk-wrap">
                          <span class="text-decoration" v-if="item.package_real_flag === '1'" :style="operateTextStyle"
                            @click="$emit('fill-address')">填写地址</span>
                          <template v-if="item.package_cdkey">
                            <span :style="operateTextStyle" v-if="threeCards.includes(item.cdKeyType)"
                              @click="bindQRCode(item.package_cdkey)">查看二维码</span>
                            <span class="text-decoration" v-else :style="operateTextStyle"
                              @click="copyText(item.package_cdkey, item.gift_id)">复制CDKEY</span>
                          </template>
                        </div>
                    </template>
                    <template v-else>
                      <span :style="operateTextStyle">-</span>
                    </template>
                  </li>
                </ul>
              </div>

            </template>
            <!-- 物品记录 -->
            <template v-if="list.length === 0">
              <div class="win-prize-body-empty-record-msg" :style="prizeRecordItemCommonStyle">
                还没获得奖品，快去参加活动吧
              </div>
            </template>
            <template v-if="list.length > 0">
              <div class="win-prize-body-page" v-if="Math.ceil(page.total / pageSize) >= 1">
                <span @click="page.current > 1 && page.current--" :style="pageSizeItemCommonStyle">上一页</span>
                <span class="win-prize-body-page-num" :style="pageSizeItemCommonStyle">
                  {{ page.current }}/{{ Math.ceil(page.total / pageSize) }}</span>
                <span @click="page.current < page.total / pageSize && page.current++"
                  :style="pageSizeItemCommonStyle">下一页</span>
              </div>
            </template>
          </div>
        </div>

      </div>
      <!-- 二维码弹框 -->
      <c-dialog v-model="isShowCdkey" :option="cdkeyPopOption" @close="isShowCdkey = false">
        <template slot="body">
          <div class="cdkey-qrcode-box">
            <vue-qrcode :value="qrcodeUrl" type="image/png" :color="{ dark: '#000000ff', light: '#ffffffff' }"
              class="vue-qrcode">
            </vue-qrcode>
            <div class="qrcode-title">您的悦享卡兑换激活码，可截图保存或长按识别</div>
          </div>
        </template>
      </c-dialog>
    </template>
  </c-dialog>
</template>

<script>
import { ClaimRecord } from '../apis';
// import CDialog from '../base-dialog';
import CDialog from '../ceiba-dialog';
import common from '../../common';
import Vue from 'vue';
import VueQrcode from 'vue-qrcode';

export default {
  name: 'package-claim-record',
  components: {
    // [CDialog.name]: CDialog,
    [CDialog.name]: CDialog,
    VueQrcode,
  },
  props: {
    gameCode: String,
    params: Object,
    backgroundImage: String,
    hidePackageIds: Array,
    fontColor: {
      type: String,
      default: '#000',
    },
    option: Object,
    pageSize: Number,
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      list: [],
      page: {
        current: 1,
        total: 0,
      },
      isShow: true,
      flowVersion3: 2,
      isMaterial: '1', // 实物状态码
      redirectTrips: '', // 跳转提示文案
      redirectUrl: '', // 跳转链接
      popupsIndex: -1, // 弹出层下标
      isShowCdkey: false,
      threeCards: ['month', 'hmc', 'once'],
      qrcodeUrl: '',
      // 跳转wx,qq福利中心相关配置
      WXWelfareCenterURL: '',
      QQWelfareCenterURL: '',
      tabCurrentIndex: 1, // 当前显示的tab标题 默认领取礼包
    };
  },
  computed: {
    PrizeBodyRecordScrollStyle() {
      const overflow = !this.isMobile ? 'visible' : 'hidden';
      return {
        overflowY: this.list.length <= 6 ? overflow : 'scroll',
        // 动态主体高度 只有一个tab 高度固定 3.64rem, 两个tab 则减去 tab 的0.54rem
        '--dynamic-height': this.params?.isResourcesIssue ? '3.06rem' : '3.64rem', // 支持tab 和不配置tab 实际渲染高度不一致
      };
    },
    // tab标题 用户信息传入的标题配置
    tabTitle() {
      return this.params?.tab_title || {};
    },
    // 获奖记录列标题 用户信息传入的标题配置
    itemTitle() {
      return this.option?.itemTitle || [];
    },
    winPrizeRecordBottomBorderStyle() {
      return {
        // borderBottom: `${!this.isMobile
        //   ? '0px' : '0.02rem'} solid ${this.popStyleTextRgba.color10}`,
      };
    },
    winPrizeRecordTitleBgStyle() {
      return { backgroundColor: !this.isMobile ? '#F7F9FA' : this.popStyleTextRgba.color10 };
    },
    pageSizeItemCommonStyle() {
      return {
        color: !this.isMobile ? '#8E8E93' : this.popStyleTextRgba.color50,
      };
    },
    prizeRecordItemTitleCommonStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color50,
      };
    },
    prizeRecordItemCommonStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color100,
        '--empty-top-height': this.params?.isResourcesIssue ? '29%' : '33%', // 支持tab 和不配置tab 实际渲染高度不一致
      };
    },
    // tab标题底部边框线颜色、字体颜色
    tabTitleborderStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color100,
        '--tab-title-border-color': !this.isMobile ? '2px solid #242424' : `2px solid ${this.popStyleTextRgba.color100}`,
      };
    },
    prizeRecordItemTimeStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color100,
      };
    },
    popStyleTextRgba() {
      const hexToRgba = (hex, opacity) => `rgba(${parseInt(`0x${hex.slice(1, 3)}`, 16)}
      ,${parseInt(`0x${hex.slice(3, 5)}`, 16)},${parseInt(`0x${hex.slice(5, 7)}`, 16)},${opacity})`;
      return {
        color100: this.popTextStyle.color,
        color50: hexToRgba(this.popTextStyle.color, 0.5),
        color80: hexToRgba(this.popTextStyle.color, 0.8),
        color10: hexToRgba(this.popTextStyle.color, 0.10),
      };
    },
    popTextStyle() {
      const { dialogStyle = {} } = this.option;
      let color = dialogStyle?.color;
      if (!color) {
        color = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.dialogStyle?.color || '#ffffff';
      }
      return { color };
    },
    // 标题文案样式
    titleTextStyle() {
      const { titleStyle = {} } = this.option;
      let color = titleStyle?.color;
      if (!color) {
        color = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.titleColor || '#ffffff';
      }
      return { color };
    },
    operateTextStyle() {
      const { operateStyle = {} } = this.option || {};
      if (!this.isMobile) {
        operateStyle.color = '#1D3F7C';
      }
      if (!operateStyle.color) {
        operateStyle.color = this.popTextStyle.color;
      }
      console.log('操作文本样式operateTextStyle =', operateStyle);
      return operateStyle;
    },
    popOption() {
      // 用户配置
      console.log('---  user  setting  popConfig ---- ', this.option, this.backgroundImage);
      // 读取传入width, height
      const { titleStyle = {}, dialogStyle: dialogStyleOption = {}, width, height } = this.option || {};
      // 新增标题颜色
      if (!titleStyle.color) {
        titleStyle.color = this.titleTextStyle?.color;
      }
      // eslint-disable-next-line max-len, vue/max-len
      const { dialogStyle = {}, closeLocation } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      let { closeStyle = {} } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      let bgImageStyle = '';
      if (typeof this.backgroundImage === 'string' && this.backgroundImage) {
        bgImageStyle = `url(${this.backgroundImage})`;
      }
      const bgImageReg = /(https:|http:)?\/\/[^\s]*$/;
      if (!bgImageStyle && dialogStyleOption.backgroundImage && bgImageReg.test(dialogStyleOption.backgroundImage)) {
        bgImageStyle = dialogStyleOption.backgroundImage;
      }
      if (!bgImageStyle && dialogStyle.backgroundImage && bgImageReg.test(dialogStyle.backgroundImage)) {
        bgImageStyle = dialogStyle.backgroundImage;
      }
      if (!closeStyle.backgroundImage || !bgImageReg.test(closeStyle.backgroundImage)) {
        closeStyle = '';
      }
      let dlgHeader = !this.isMobile ? '中奖记录' : '获奖记录';
      if (!!this.option.header) {
        dlgHeader = this.option.header;
      }
      const popConfig = {
        header: dlgHeader,
        titleStyle: { fontSize: '0.36rem', borderBottom: 'none', fontWeight: 600, ...titleStyle },
        close: true,
        closeLocation: !this.isMobile ? 'top-right' : closeLocation,
        height,
        width,
        confirm: false,
        footer: false,
        closeStyle: !this.isMobile ? {
          backgroundImage: 'url(https://act.supercore.qq.com/activity/supercore/14161/be052f80d9bba6a5888eb12b6b045ffa.png)',
        } : closeStyle,
        dialogStyle: Object.assign(
          {},
          {
            color: this.popTextStyle.color,
            backgroundImage: bgImageStyle,
          },
        ),
      };
      // 设置默认的width, height
      if (!popConfig.width) {
        popConfig.width = '6rem';
      }
      if (!popConfig.height) {
        popConfig.height = '6rem';
      }
      // 如果传入高度低于  6rem 则强制用 6rem
      if (parseFloat(popConfig.height) < 6) {
        popConfig.height = '6rem';
      }
      console.log('--------------------  final reward window popConfig  ------------= ', popConfig);
      return popConfig;
    },
    // 二维码弹框配置
    cdkeyPopOption() {
      const { dialogStyle: dialogStyleOption = {} } = this.option || {};
      const {
        closeStyle = {},
        dialogStyle = {},
        closeLocation,
      } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      let bgImageStyle = '';
      if (typeof this.backgroundImage === 'string' && this.backgroundImage) {
        bgImageStyle = `url(${this.backgroundImage})`;
      }
      const bgImageReg = /(https:|http:)?\/\/[^\s]*$/;
      if (!bgImageStyle && dialogStyleOption.backgroundImage && bgImageReg.test(dialogStyleOption.backgroundImage)) {
        bgImageStyle = dialogStyleOption.backgroundImage;
      }
      if (!bgImageStyle && dialogStyle.backgroundImage && bgImageReg.test(dialogStyle.backgroundImage)) {
        bgImageStyle = dialogStyle.backgroundImage;
      }
      const popConfig = {
        header: '',
        titleStyle: { fontSize: '0.14rem', borderBottom: 'none', fontWeight: 500, height: '.2rem' },
        close: true,
        closeLocation,
        height: '230px',
        width: '230px',
        confirm: false,
        footer: false,
        closeStyle,
        dialogStyle: Object.assign(
          {},
          {
            color: this.popTextStyle.color,
            backgroundImage: bgImageStyle,
          },
        ),
      };
      return popConfig;
    },
  },
  watch: {
    'page.current'() {
      this.freshList();
    },
  },
  async mounted() {
    await this.freshList();
    if (!this.isMobile && this.list.length > 0) {
      const that = this;
      document.addEventListener('click', (e) => {
        if (!that.$refs?.textDecorationPopups[that.popupsIndex]?.contains(e.target)) {
          that.popupsIndex = -1;
        }
      });
    }
  },
  destroyed() {
    if (!this.isMobile) {
      const that = this;
      document.removeEventListener('click', (e) => {
        if (!that.$refs?.textDecorationPopups[that.popupsIndex]?.contains(e.target)) {
          that.popupsIndex = -1;
        }
      });
    }
  },
  methods: {
    getConfigFromActInfo(giftId, type) {
      const receiveGiftCustomConfig = Vue.prototype?.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      return receiveGiftCustomConfig
        ?.find(item => String(giftId).includes(item.gift_id) && item.type === type);
    },
    // 优先判断
    checkIsSurvey(giftId) {
      const id = parseInt(giftId, 10);
      if (!id) return false;
      const record = this.getConfigFromActInfo(giftId, 'privateQualification');
      if (record) {
        return true;
      }
      return false;
    },
    // 优先匹配个性化礼包类型
    checkIsMatchGift(giftId, type) {
      const id = parseInt(giftId, 10);
      if (!id) return false;
      const record = this.getConfigFromActInfo(giftId, type);
      if (record) {
        return true;
      }
      return false;
    },
    actionByType(giftId, type) {
      if (!type) {
        return;
      }
      const record = this.getConfigFromActInfo(giftId, type);
      if (!record) {
        return;
      }
      switch (type) {
        case 'privateQualification': {
          const { link = '' } = record?.playload ?? {};
          if (link) {
            window.location.href = link;
          }
        }
          break;
      }
    },
    async freshList() {
      if (this.$isInEditor) {
        this.list = new Array(this.pageSize).fill({
          gift_time: '2021-10-21 12:00:00',
          gift_name: '紫晶石*888',
          show_gift_name: '紫晶石*888',
          package_real_flag: '1',
        });
        this.page.total = 11;
        return;
      }
      const bushandang = Vue.prototype?.$actInfo?.extendConfig?.bushandang || false;
      if (this.tabCurrentIndex === 2) {
        const response = await ClaimRecord.getResourcesRecords({
          game_code: bushandang ? '' : this.gameCode,
          ...this.params,
          page_size: this.pageSize,
          page_index: (this.page.current - 1) * this.pageSize, // 后台接口要求：页数 * 每页显示的条数 第一页传 0
        });
        if (response.ret && response.ret !== 0) {
          this.alert(response.msg || '系统繁忙，请刷新页面重试');
          return;
        }
        this.page.total = response.data.total;
        this.list = response.data?.list || [];
        this.list.map(async (i, listIndex) => {
          const item = i;
          item.gift_time = item?.delivered_at > 0 ? this.timeTrans(item.delivered_at) : '';
          const giftNames = [];
          const giftPackageId = [];
          let packageRealFlag = '0';
          for (let k = 0; k < item.groups.length; k++) {
            // 是否存在排除礼包配置  并且当前礼包是否是排除礼包
            if (this.hidePackageIds && this.hidePackageIds.indexOf(item.groups[k].package_id) > 0) {
              continue;
            }
            if (parseInt(item.groups[k].amount, 10) > 0) {
              giftNames.push(`${item.groups[k].package_name} ${item.groups[k].amount}个`);
            } else {
              giftNames.push(item.groups[k].package_name);
            }
            giftPackageId.push(item.groups[k].package_id);
            if (item.groups[k].attached === this.isMaterial) {
              packageRealFlag = this.isMaterial;
            }
          }
          // 排除礼包后还存在数据 记录
          if (giftNames.length > 0) {
            item.gift_name = giftNames.join(',');
            item.package_real_flag = packageRealFlag;
            item.gift_id = giftPackageId.join(',');
            item.show_gift_name = giftNames.join(',');
            item.gift_name = item.show_gift_name;
            if (item.show_gift_name.length > 10) item.show_gift_name = item.show_gift_name.substr(0, 10);
            if (this.params.business_id === 'bb') {
              item.partition_name = common.tool.Base64.decode(item.partition_name);
            }
            this.list[listIndex] = item;
          }
          item.show_gift_time = this.timeShowFunc(parseInt(item.delivered_at, 10) * 1000);
          const cdKeyType = item.package_cdkey ? await this.getCdKeyType(item.package_cdkey) : '';
          this.$set(item, 'cdKeyType', cdKeyType);
          return item;
        });
        console.log('-------------------- this.list 资源发货 = ', this.list);
      } else {
        let retClaim;
        let msg = '';
        ({ ret: retClaim, records: this.list, total: this.page.total, msg } = await ClaimRecord.getClaimRecords({
          game_code: bushandang ? '' : this.gameCode,
          ...this.params,
          page_size: this.pageSize,
          page_index: this.page.current,
        }));
        if (retClaim !== 0) {
          this.alert(msg || '系统繁忙，请刷新页面重试');
          return;
        }
        if (this.hidePackageIds) {
          // this.list = this.list.filter(i => !~this.hidePackageIds.indexOf(i.gift_id));
          this.list = this.handleFilterWithHidePackageIds(this.list, this.hidePackageIds);
        }
        this.list.map(async (i) => {
          const item = i;
          // 处理gift_id
          const giftIds = item.gift_id.split(',');
          const giftNames = item.gift_name.split(',');
          const newGiftNames = [];
          for (let i = 0; i < giftIds.length; i++) {
            const giftItems = giftIds[i].split(':');
            if (giftItems.length === 2 && giftItems[1] > '1') {
              newGiftNames.push(`${giftItems[1]}份 ${giftNames[i]}`);
            } else {
              newGiftNames.push(giftNames[i]);
            }
          }
          item.show_gift_name = newGiftNames.filter(i => !!i).join('、');
          // item.gift_name = newGiftNames.join(',');
          item.gift_name = item.show_gift_name;
          if (item.show_gift_name.length > 10) item.show_gift_name = item.show_gift_name.substr(0, 10);
          if (this.params.business_id === 'bb') {
            item.partition_name = common.tool.Base64.decode(item.partition_name);
          }
          item.show_gift_time = this.timeShowFunc(parseInt(item.created, 10) * 1000);
          const cdKeyType = item.package_cdkey ? await this.getCdKeyType(item.package_cdkey) : '';
          this.$set(item, 'cdKeyType', cdKeyType);
          return item;
        });
        console.log('-------------------- this.list ams单号发货 = ', this.list);
      }
    },
    // tab 标题切换
    tabTitleClick(index) {
      if (this.tabCurrentIndex === index) return;
      this.list = [];
      this.tabCurrentIndex = index;
      this.page.current = 1;
      this.freshList();
    },
    // 处理记录gift_id 返回多个 "xxx,xxx"
    // hidePackageIds 如果配置多个 "xxx,xxx"
    handleFilterWithHidePackageIds(list, hidePackageIds) {
      if (!list || list.length === 0) return [];
      // eslint-disable-next-line no-param-reassign
      list = list.map((item) => {
        let isHidden = false;
        let { gift_id: giftId, gift_name: giftName } = item;
        if (item.gift_id.indexOf(',') > -1) {
          let tempGiftIds = item.gift_id.split(',');
          const tempOriginGiftIdCount = tempGiftIds.length;
          const tempGiftName = item.gift_name.split(',');
          //  过滤要显示的
          tempGiftIds = tempGiftIds.filter((id, index) => {
            const res = hidePackageIds.indexOf(id) === -1;
            // 需要过滤不显示的礼包名称
            if (!res && typeof tempGiftName[index] !== 'undefined') {
              tempGiftName.splice(index, 1, '');
            }
            return res;
          });
          isHidden = tempGiftIds.length === 0;
          if (tempOriginGiftIdCount !== tempGiftIds.length) {
            giftId = tempGiftIds.join(',');
            giftName = tempGiftName.filter(i => !!i).join(',');
          }
        } else {
          isHidden = hidePackageIds.indexOf(item.gift_id) > -1;
        }
        return {
          ...item,
          isHidden,
          gift_id: giftId,
          gift_name: giftName,
        };
      });
      // eslint-disable-next-line no-param-reassign
      list = list.filter(i => i.isHidden === false);
      console.log('handleFilterWithHidePackageIds list=', list);
      return list;
    },
    showDetail(giftName, index) {
      if (!this.isMobile) {
        this.popupsIndex = index;
        const that = this;
        this.$nextTick(() => {
          const [decorationPopups] = that.$refs.textDecorationPopupsPointer;
          const [decorationPopupsText] = that.$refs.decorationPopupsText;
          const giftNameNum = giftName.split('、');
          if (giftNameNum.length <= 4) {
            decorationPopups.setAttribute('style', 'width: 200px');
            return;
          }
          if (decorationPopups.offsetWidth >= decorationPopupsText.offsetWidth) {
            decorationPopups.setAttribute('style', `width: ${decorationPopupsText.offsetWidth}px`);
          }
        });
      } else {
        this.alert(giftName);
      }
    },
    copyText(content, packageId) {
      // 如果有多个cdk(判断cdk中有逗号),弹窗提示
      if (content.includes(',')) {
        this.alert(`<p>你获得的cdkey是：<br><b>${content}</b><br>请长按复制cdkey码（cdkey以,分隔区分）并前往激活使用</p>`);
        return;
      }
      this.getCdkConfig(packageId);
      try {
        const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        const textarea = document.createElement('textarea');
        // Prevent zooming on iOS
        textarea.style.fontSize = '12pt';
        // Reset box model
        textarea.style.border = '0';
        textarea.style.padding = '0';
        textarea.style.margin = '0';
        // Move element out of screen horizontally
        textarea.style.position = 'absolute';
        textarea.style[isRTL ? 'right' : 'left'] = '-9999px';
        // Move element to the same position vertically
        const yPosition = window.pageYOffset || document.documentElement.scrollTop;
        textarea.style.top = `${yPosition}px`;

        textarea.setAttribute('readonly', '');

        // 赋值
        textarea.value = content;
        document.body.appendChild(textarea);
        // 选中
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        // 复制
        let succeeded;
        try {
          succeeded = document.execCommand('copy');
        } catch (err) {
          succeeded = false;
        }
        // 移除输入框
        document.body.removeChild(textarea);
        if (this.redirectUrl !== '') {
          const that = this;
          this.alert({ msg: this.redirectTrips, confirm() {
            window.location.href = that.redirectUrl;
          } });
        } else {
          this.alert(`复制${succeeded ? '成功' : '失败'}`);
        }
      } catch (e) {
      }
    },
    // 前往福利中心
    goToWelfareCenter(packageId) {
      this.getWelfareCenterConfig(packageId);
      const acctype = common.tool.getCookie('acctype');
      if (acctype === 'wx') {
        window.location.href = this.WXWelfareCenterURL;
        return;
      }
      window.location.href = this.QQWelfareCenterURL;
      return;
    },
    // 获取福利中心卡券相关配置
    getWelfareCenterConfig(packageId) {
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      const res = receiveGiftCustomConfig?.find(item => String(packageId).includes(item.gift_id));
      this.WXWelfareCenterURL = res?.playload?.WXWelfareCenterURL ?? '';
      this.QQWelfareCenterURL = res?.playload?.QQWelfareCenterURL ?? '';
      return;
    },
    getCdkConfig(packageId) {
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      const res = receiveGiftCustomConfig?.find(item => String(packageId).includes(item.gift_id));
      this.redirectTrips = res?.playload?.redirectTrips ?? '立即前往兑换权益';
      this.redirectUrl = res?.playload?.redirectUrl ?? '';
    },
    timeTrans(timeStr) {
      const date = new Date(timeStr * 1000); // 如果date为13位不需要乘1000
      const Y = `${date.getFullYear()}-`;
      const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
      const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} `;
      const h = `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:`;
      const m = `${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}:`;
      const s = (date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds());
      return Y + M + D + h + m + s;
    },
    // 毫秒时间戳
    timeShowFunc(time) {
      if (!time) {
        return '-';
      }
      const date = new Date(time);
      const Y = `${date.getFullYear()}-`;
      const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
      const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} `;
      const h = `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:`;
      const m = `${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;
      return `${Y}${M}${D} ${h}${m}`;
    },
    // 获取卡类型
    async getCdKeyType(cdkey) {
      const res = await ClaimRecord.getQueryCdkType({ cdkey });
      const { ret, data } = res;
      if (ret !== 0) {
        this.alert(res.msg || '系统繁忙，请刷新页面重试');
        return;
      }
      const { ret: retRet, info } = data || {};
      if (retRet === 0) {
        return info.business_name;
      }
      return '';
    },
    // 二维码
    async bindQRCode(cdkey) {
      const gid = Vue.prototype?.$storeInstance?.getters?.currentGid;
      this.qrcodeUrl = `https://xinyue.qq.com/act/a20210623cardCenter/index.html#/?redemption_code=${cdkey}&gid=${gid}`;
      this.isShowCdkey = true;
    },
  },
};
</script>

<style scoped>
.dialog {
  font-size: 0.2rem;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 6rem;
  position: relative;
}

.dialog--pc {
  font-size: 20px;
  width: 600px;
  display: block;
  height: 100%;
  position: static;
}

.dialog-content {
  text-align: center;
  margin: 0 auto;
}

.dialog--default .win-prize-body {
  width: 5.6rem;
  height: 4.84rem;
}

.dialog--default .tab-title {
  margin-top: -0.1rem;
  margin-bottom: 0.22rem;
}

.dialog--default .tab-title-left,
.dialog--default .tab-title-right {
  display: inline-block;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 0.26rem;
  margin: 0 0.36rem;
  text-align: center;
}
.dialog--default .tab-title-left.tab-title-active,
.dialog--default .tab-title-right.tab-title-active {
  border-bottom: var(--tab-title-border-color);
}


.dialog--default .win-prize-body-title {
  width: 5.6rem;
  height: 0.5rem;
  line-height: 0.5rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  text-align: center;
  border-radius: 0.1rem;
}

.dialog--default .win-prize-body-title .win-prize-body-title-name {
  padding-left: 0.2rem;
  width: 2rem;
}

.dialog--default .win-prize-body-title .win-prize-body-title-time {
  padding-left: 0.1rem;
  width: 2rem;
}

.dialog--default .win-prize-body-title .win-prize-body-title-action {
  padding-left: 0.2rem;
  width: 1.6rem;
}

.dialog--default .win-prize-body-record .win-prize-body-record-name {
  padding-left: 0.2rem;
  width: 2rem;
}

.dialog--default .win-prize-body-record .win-prize-body-record-time {
  width: 2rem;
  padding-left: 0.1rem;
  font-size: 0.2rem;

}

.dialog--default .win-prize-body-record .win-prize-body-record-action {
  padding-left: 0.2rem;
  width: 1.6rem;
}

.dialog--default .win-prize-body-record .win-prize-body-record-note {
  padding-left: 0.2rem;
  width: 1.6rem;
}

.win-prize-body-record .address-cdk-wrap {
  height: 0.6rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.win-prize-body-record .address-cdk-wrap span {
 line-height: 0.31rem;
}

.win-prize-body-record .text-decoration {
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 1.7rem;
}
.win-prize-body-record .text-weight {
  font-weight: 600;
}


.dialog--default .win-prize-body-title li {
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  text-align: left;
}

.win-prize-body-record-scroll-window {
  /* 高度 (0.65 + 0.02（边框） ) *  6 */
  height: var(--dynamic-height);
  max-height: var(--dynamic-height);
  margin-top: 0.16rem;
}

.dialog--default .win-prize-body-record {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  justify-content: flex-start;
}

.dialog--default .win-prize-body-record li {
  width: 5.6rem;
  height: 0.48rem;
  line-height: 0.48rem;
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  text-align: center;
  list-style: none;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

.dialog--default .win-prize-body-empty-record-msg {
  letter-spacing: 1px;
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  margin: 0 auto;
  margin-top: var(--empty-top-height);
}

.dialog--default .win-prize-body-page {
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
}

.dialog--default .win-prize-body-page .win-prize-body-page-num {
  margin: 0 0.7rem;
}

.win-prize-body-record-time {
  white-space: nowrap;
}

.cdkey-qrcode-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* pc */
.dialog--pc .win-prize-body {
  width: 100%;
  height: 100%;
  padding: 0 24px;
}

.dialog--pc .tab-title {
  margin-top: -5px;
  margin-bottom: 11px;
}

.dialog--pc .tab-title-left,
.dialog--pc .tab-title-right {
  display: inline-block;
  height: 18px;
  line-height: 18px;
  font-size: 13px;
  margin: 0 18px;
  text-align: center;
}
.dialog--pc .tab-title-left.tab-title-active,
.dialog--pc .tab-title-right.tab-title-active {
  border-bottom: var(--tab-title-border-color);
}

.dialog--pc .win-prize-body-title {
  width: 100%;
  height: 50px;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  text-align: center;
  border-radius: 6px;
}

.dialog--pc .win-prize-body-title li {
  font-style: normal;
  line-height: 50px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  text-align: left;
}

.dialog--pc .win-prize-body-record {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
  margin: 12px 0;
}

.dialog--pc .win-prize-body-title .win-prize-body-title-name {
  margin-left: 10px;
  width: 150px;
}

.dialog--pc .win-prize-body-title .win-prize-body-title-time {
  margin-left: 10px;
  width: 180px;
}

.dialog--pc .win-prize-body-title .win-prize-body-title-action {
  margin-left: 10px;
  width: 100px;
}

.dialog--pc .win-prize-body-record .win-prize-body-record-name {
  margin-left: 10px;
  width: 150px;
  position: relative;
  display: inline-block;
}

.dialog--pc .win-prize-body-record .win-prize-body-record-time {
  margin-left: 10px;
  font-size: 14px;
  width: 180px;
}

.dialog--pc .win-prize-body-record .win-prize-body-record-action {
  margin-left: 10px;

  width: 100px;
}
.dialog--pc .win-prize-body-record .win-prize-body-record-note {
  margin-left: 10px;

  width: 100px;
}
.dialog--pc .win-prize-body-empty-record-msg {
  letter-spacing: 1px;
  font-family: PingFang SC;
  font-style: normal;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 29%;
  margin-bottom: 29%;
}

.dialog--pc .win-prize-body-record li {
  width: 560px;
  height: 32px;
  line-height: 32px;
  font-weight: 400;
  font-family: PingFang SC;
  font-style: normal;
  text-align: left;
  list-style: none;
  font-family: PingFang SC;
  font-size: 14px;
  letter-spacing: 0px;
  text-align: left;
}

.cdkey-qrcode-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.cdkey-qrcode-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dialog--pc .win-prize-body-record-scroll-window {
  /* 高度 (0.65 + 0.02（边框） ) *  6 */
  height: 364px;
  border-bottom: 1px solid #EBEBEB;
  padding-bottom: 12px;
  max-height: 364px;
}

.dialog--pc .win-prize-body-page {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFang SC;
  font-style: normal;
  margin: 20px 0;
}

.dialog--pc .win-prize-body-page .win-prize-body-page-num {
  margin: 0 70px;
}

.dialog--pc .win-prize-body-record .address-cdk-wrap {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dialog--pc .win-prize-body-record .address-cdk-wrap span {
 line-height: 25px;
}

.dialog--pc .win-prize-body-record .text-decoration {
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 135px;
  color: #1D3F7C;
  font-weight: 600;
}
.dialog--pc .win-prize-body-record .text-weight {
  font-weight: 600;
}

.dialog--pc .text-decoration-popups {
  width: 1366px;
  max-width: 452px;
  max-height: 100px;
  min-width: 200px;
  background-color: #000;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  border-radius: 15px;
  bottom: 35px;
  z-index: 99;
  animation: pop-open 0.3s 1;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  box-sizing: content-box;
  display: inline-block;
}

.dialog--pc .text-decoration-popups-pointer {
  position: absolute;

  width: 0px;
  height: 0px;
  border: 9px solid transparent;
  /* border: 18px solid rgba(0,0,0,0.7); */
  border-bottom-color: transparent;
  border-top-color: rgba(0, 0, 0, 0.6);
  border-left-color: transparent;
  border-right-color: transparent;
  bottom: -18px;
  left: 80px;
  transform: translateX(-50%);
}

.dialog--pc .text-decoration-popups p {
  /* max-width: 452px;
  min-width: 200px;
  max-height: 100px; */
  width: fit-content;
  display: block;
  /* height: 100px; */
  color: #fff;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  z-index: 99;
}

@keyframes pop-open {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes pop-close {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.cdkey-qrcode-box .vue-qrcode {
  width: 2.5rem;
  height: 2.5rem;
}

.cdkey-qrcode-box .qrcode-title {
  width: 100%;
  text-align: center;
  font-size: 0.14rem;
  color: black;
  margin-top: .2rem;
  padding: 0 .2rem;
}
</style>
